import { useQuery } from "@tanstack/react-query"

import apiClient from "@api/client"
import { QUERY_KEYS } from "@api/constants"
import { DeliveryAddress } from "@models/deliveryAddress"

export const useDefaultDeliveryAddress = () =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_DEFAULT_DELIVERY_ADDRESS],
    queryFn: async () => {
      const res = await apiClient.get("user/delivery-address/default")

      if (res?.statusCode === 200) {
        const address = DeliveryAddress.fromDynamic((res.body as any).address)
        return address
      }
    },
  })
